module.exports = __webpack_public_path__ + "img/symbol_1.121d78a4.png";